import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import Accordion from "react-bootstrap/Accordion";
import Modal from "react-bootstrap/Modal";
import Slider from "react-slick";
import { URLS } from "../Url";
import Footer from "./Footer";
import Header from "./Header";
import Typer from "./Typer";
import axios from "axios";
import roses from "./images/roses.jpg";
import cake4 from "./images/cake 4.jpg";
import { FaStar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Galleria } from "primereact/galleria";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import beverages from "./images/foodbeverages.jpg";
import screening from "./images/screening.jpg";
import { Helmet } from "react-helmet";
import {
  faUser,
  faPhone,
  faEnvelope,
  faCalendarAlt,
  faClipboard,
} from "@fortawesome/free-solid-svg-icons";
import logo from "../components/carnival_footer_logo-2-removebg-preview.png";

import { Carousel, Card, Container, Row, Col, Button } from "react-bootstrap";
import CouponSection from "./Coupons";
import Time from "../Blogs/Time";
import PopupModal from "./PopUpModal";
import HomePackagesSection from "./PackageSection";

export const fetchPopupImage = async () => {
  try {
    const res = await fetch(
      "https://api.carnivalcastle.com/v1/carnivalApi/admin/popup/getpopupimage?type=CarnivalCastle"
    );

    const data = await res.json();

    if (data.success && data.data?.length > 0) {
      return data.data[0]; // return first popup
    }

    return null;
  } catch (error) {
    console.error("Popup fetch error:", error);
    return null;
  }
};


function Home() {


  const [isLoading, setIsLoading] = useState(false);

  const [form, setform] = useState({
    name: "",
    email: "",
    mobileNumber: "",
    description: "",
    eventName: "",
  });

  useEffect(() => {
    GetHomePage();
    GetAllGalleryDate();
  }, []);

  const [Faqs, setFaqs] = useState([]);
  const [Sliders, setSliders] = useState([]);
  console.log(Sliders);
  const [Howtojoin, setHowtojoin] = useState([]);
  const [LatestInfo, setLatestInfo] = useState([]);
  const [LatestInfos, setLatestInfos] = useState([]);
  console.log(LatestInfos);
  const [Highlights, setHighlights] = useState([]);
  const [Testimonial, setTestimonial] = useState([]);
  const [Howtojoinpoints, setHowtojoinpoints] = useState([]);
  const [HighlightsPoints, setHighlightsPoints] = useState([]);

  const [Offers, setOffers] = useState([]);
  const [services, setservices] = useState([]);

  const [Contact, setContact] = useState([]);

  const navigate = useNavigate();

  const [PopUp, setPopUp] = useState([]);

  const GetHomePage = () => {
    axios.post(URLS.AllModules, {}, {}).then((res) => {
      if (res.status === 200) {
        setFaqs(res?.data?.faqs);
        setContact(res?.data?.contactus[0]);
        setSliders(res?.data?.homesliders);
        setTestimonial(res?.data?.testimonials);
        setHowtojoin(res?.data?.howtojoin[0]);
        setHighlights(res?.data?.highlight[0]);
        setLatestInfo(res?.data?.latestinfo[0]);
        setLatestInfos(res?.data?.latestinfo[0]?.count);
        setHighlightsPoints(res?.data?.highlight[0]?.features);
        setHowtojoinpoints(res?.data?.howtojoin[0]?.benefits);
        setPopUp(res?.data?.popup[0]);
        setOffers(res?.data?.offer);
        setservices(res?.data?.occasions);
        setLgShow(res?.data?.popup[0]?.popupBoolean);
        setIsLoading(false);
      }
    });
    sessionStorage.clear();
  };

  const formsubmit = (e) => {
    e.preventDefault();
    EnquiryNow();
  };

  const handleChange = (e) => {
    let myUser = { ...form };
    myUser[e.target.name] = e.target.value;
    setform(myUser);
  };

  const EnquiryNow = () => {
    const dataArray = {
      name: form.name,
      email: form.email,
      mobileNumber: form.mobileNumber,
      description: form.description,
      eventName: form.eventName,
    };

    axios.post(URLS.AddEnquiry, dataArray).then(
      (res) => {
        if (res.status === 200) {
          toast(res.data.message);
          setform({
            name: "",
            email: "",
            mobileNumber: "",
            description: "",
            eventName: "",
          });
        }
      },
      (error) => {
        if (error.response && error.response.status === 400) {
          toast(error.response.data.message);
        }
      }
    );
  };

  const [showAllFaqs, setShowAllFaqs] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [popupImage, setPopupImage] = useState("");

  useEffect(() => {
    const loadPopup = async () => {
      const popup = await fetchPopupImage();

      // ✅ Only open if modalEnabled is true
      if (popup?.modalEnabled) {
        setPopupImage(popup.image);
        setShowPopup(true);
      }
    };

    loadPopup();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  const settings4 = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
          arrows: false,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: false,
        },
      },
    ],
  };

  const settings2 = {
    dots: false,
    infinite: true,
    arrows: true,
    autoplay: false,
    speed: 1000,
    // slidesToShow: 4,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const settings3 = {
    dots: false,
    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [images, setImages] = useState([]);

  const GetAllGalleryDate = () => {
    axios.post(URLS.GetAllGallery, {}, {}).then((res) => {
      if (res.status === 200) {
        setImages(res?.data?.gallerys?.slice(0, 3));
      }
    });
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const galleria = useRef(null);

  const itemTemplate = (item) => {
    return (
      <img
        src={URLS.Base + item.image}
        alt={item.alt}
        style={{ width: "100%", display: "block" }}
      />
    );
  };

  const thumbnailTemplate = (item) => {
    return (
      <img
        src={URLS.Base + item.image}
        alt={item.alt}
        style={{ display: "block" }}
      />
    );
  };

  const [timeLeft, setTimeLeft] = useState(39639);

  useEffect(() => {
    if (timeLeft <= 0) return;
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return {
      hours: hours.toString().padStart(2, "0"),
      minutes: minutes.toString().padStart(2, "0"),
      seconds: seconds.toString().padStart(2, "0"),
    };
  };

  const { hours, minutes, seconds } = formatTime(timeLeft);

  const [Theaters, setTheaters] = useState([]);

  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    GetTheatersData();
  }, []);

  const GetTheatersData = () => {
    axios.post(URLS.GetAllTheaters, {}, {}).then((res) => {
      if (res.status === 200) {
        setTheaters(res.data.theatres);
      }
    });
  };

  const today = new Date();

  const [date, setDate] = useState(today);

  const dateString = date;

  const dateObject = new Date(dateString);

  const dd = dateObject.getDate().toString().padStart(2, "0");
  const mm = (dateObject.getMonth() + 1).toString().padStart(2, "0");
  const yyyy = dateObject.getFullYear();

  const formattedDateString = `${yyyy}-${mm}-${dd}`;

  const databyid = (data) => {
    sessionStorage.clear();
    axios.post(URLS.GetUnicId, {}, {}).then((res) => {
      if (res.status === 200) {
        sessionStorage.setItem("UserId", res.data.userId);
        sessionStorage.setItem("Theaterid", data._id);
        sessionStorage.setItem("theatreName", data.name);
        sessionStorage.setItem("theatrePrice", data.offerPrice);
        sessionStorage.setItem("date", formattedDateString);
        window.location.href = "/BookingDetails";
      }
    });
  };

  const navigateTheater = useNavigate();
  const handleTheater = () => {
    navigateTheater("./locations");
  };

  const [PopUp1, setPopUp1] = useState([]);

  useEffect(() => {
    GetFooterData();
  }, []);

  const GetFooterData = () => {
    axios.post(URLS.GetFooter, {}, {}).then((res) => {
      if (res.status === 200) {
        setContact(res.data.contactus);
        setPopUp1(res.data.popup[0]);
      }
    });
  };

  const [lgvis, setLgVis] = useState(false);

  const modelShow = () => {
    setLgVis(!false);
  };



  const packages = [
    // {
    //   id: 1,
    //   title: "Basic Plan",
    //   price: "2149",
    //   subtitle: "Simple theatre slot, no setup",
    //   detailedFeatures: {
    //     "Theatre Hall": true,
    //     "Decoration": true,
    //     "Fog Entry (1 Pot)": false,
    //     "Candle Path": false,
    //     "HBD LED": false,
    //     "Name with LED (6)": false,
    //     "AGE Number LED": false,
    //     "HBD with Rose petals": false,
    //     "Photo Clipping (10)": false,
    //     "Birthday Sash": false,
    //     "Birthday Crown, Spects": false,
    //     "Rose Bouquet (12 Roses)": false,
    //     "Customisation cake (1 kg)": false,
    //     "Photography (30 Mins)": false,
    //     "Cold fire entry (6 pieces)": false,
    //     "Videography(Edited 1 Min Reel)": false,
    //     "Hall fog (4 Pots)": false,
    //   },
    //   badgeText: "Saved ₹0",
    //   buttonText: "Proceed →",
    // },
    {
      id: 2,
      title: "Standard Plan",
      subtitle: "Includes cake, lights & decor.",
      detailedFeatures: {
        "Theatre + Decoration": true,
        "Fog Entry (1 Pot)": true,
        "Candle Path": true,
        "HBD LED": true,
        "Name with LED (6)": true,
        "AGE Number LED": true,
        "HBD with Rose Petals": true,
        "Photo Clipping (10)": true,
        "Birthday Sash": true,
        "Birthday Crown, Spects": true,
        "Rose": true,
        "Regular Cake - 1/2 kg": true,
        "Photography (15 Mins)": true,
        "Cold fire entry (6 pieces)": false,
        "Videography(Edited 1 Min Reel)": false,
        "Hall fog (4 Pots)": false,
      },
      badgeText: "Save ₹200",
      buttonText: "Proceed →",
    },
    {
      id: 3,
      title: "Special Plan",
      subtitle: "Our grandest experience, full royal vibes.",
      detailedFeatures: {
        "Theatre + Decoration": true,
        "Fog Entry (1 Pot)": true,
        "Candle Path": true,
        "HBD LED": true,
        "Name with LED (6)": true,
        "AGE Number LED": true,
        "HBD with Rose petals": true,
        "Photo Clipping (10)": true,
        "Birthday Sash": true,
        "Birthday Crown, Spects": true,
        "Rose Bouquet (6 Roses)": true,
        "Customisation cake (1 kg)": true,
        "Photography (30 Mins)": true,
        "Cold fire entry (4 pieces)": true,
        "Videography(Edited 1 Min Reel)": false,
        "Hall fog (4 Pots)": false,
      },
      badgeText: "Save ₹400",
      buttonText: "Proceed →",
    },
    {
      id: 4,
      title: "Premium Plan",
      subtitle: "More guests, more upgrades, more glam.",
      detailedFeatures: {
        "Theatre + Decoration": true,
        "Fog Entry (1 Pot)": true,
        "Candle Path": true,
        "HBD LED": true,
        "Name with LED (6)": true,
        "AGE Number LED": true,
        "HBD with Rose petals": true,
        "Photo Clipping (10)": true,
        "Birthday Sash": true,
        "Birthday Crown, Spects": true,
        "Rose Bouquet (12 Roses)": true,
        "Customisation cake (1 kg)": true,
        "Photography (30 Mins)": true,
        "Cold fire entry (6 pieces)": true,
        "Videography(Edited 1 Min Reel)": true,
        "Hall fog (4 Pots)": true,
      },
      badgeText: "Save ₹300",
      buttonText: "Proceed →",
    },
  ];



  const [showMore, setShowMore] = useState({});




  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);

  const startAutoRotate = () => {
    intervalRef.current = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % whyUsSlides.length);
    }, 6000);
  };

  const stopAutoRotate = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  useEffect(() => {
    startAutoRotate();
    return () => stopAutoRotate();
  }, []);

  const handleSelect = (selectedIndex) => {
    stopAutoRotate();
    setIndex(selectedIndex);
    startAutoRotate(); // restart timer on manual select
  };
  const whyUsSlides = [
    {
      image: URLS?.Base + Highlights?.image, // Replace with dynamic images
      title: "Why Choose CarnivalCastle Private Theatre?",
      subtitle:
        "At CarnivalCastle, we believe every celebration deserves a cinematic experience — intimate, exclusive and unforgettable. Here’s why our private theatre stands out:",
      points: [
        "Perfect for Every Occasion: Themed decorations, cakes, fog effects & photography.",
        "Luxurious Ambience: Recliners, premium sound, elegant decor.",
        "Budget-Friendly Luxury: Combo offers & rewards for every budget.",
        "Prime Location in Hyderabad: Easily accessible, cozy, and convenient.",
        "End-to-End Convenience: WhatsApp support, décor add-ons & great food."
      ]
    },
    {
      image: "https://api.carnivalcastle.com/uploads/galleryImg/1728132797148-DSC07601.jpg", // Replace with another image
      title: "Celebrate Cinematically!",
      subtitle:
        "Experience celebrations like never before in our private theatres — where entertainment meets exclusivity.",
      points: [
        "Customizable Packages: Tailor your party exactly how you like it.",
        "Gourmet Snacks & Beverages: From popcorn to premium platters.",
        "Full HD Projector & Sound: A real theatre vibe, privately yours.",
        "Cozy for Everyone: Perfect for couples, families, and friends.",
        "Hassle-Free Booking: Fast, flexible & fully digital!"
      ]
    },
    {
      image: "https://api.carnivalcastle.com/uploads/galleryImg/1728132803817-DSC07593.jpg", // Replace with another image
      title: "Make Every Moment Magical",
      subtitle:
        "From surprise proposals to baby showers — bring your vision to life in an immersive, themed theatre setting.",
      points: [
        "Baby Showers, Anniversaries & More: Celebrate every milestone.",
        "Themed Decor & Props: Transform the space into your dream setting.",
        "Memorable Photo Zones: Instagram-worthy backdrops included.",
        "Night or Day Slots: Flexible celebration timings.",
        "Personalized Assistance: Our team helps plan every detail."
      ]
    }
  ];

  const [testimonials, setTestimonials] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.post(
          "https://api.carnivalcastle.com/v1/carnivalApi/admin/testimonial/getalltestimoni?websiteFor=carnivalcastle"
        );

        if (res.data?.success && Array.isArray(res.data.testimoni)) {
          // ✅ Only include testimonials that are active and have a valid videoId
          const videoTestimonials = res.data.testimoni.filter(
            (t) =>
              t.status === "active" &&
              t.videoId &&
              t.videoId.trim() !== ""
          );

          setTestimonials(videoTestimonials);
          console.log("Video Testimonials:", videoTestimonials);

          // ✅ Set first video testimonial as default selected
          if (videoTestimonials.length > 0) {
            setSelected(videoTestimonials[0]);
          }
        }
      } catch (err) {
        console.error("Error fetching testimonials:", err);
      }
    };

    fetchTestimonials();
  }, []);


  const [slides, setSlides] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.post(
          "https://api.carnivalcastle.com/v1/carnivalApi/admin/testimonial/getalltestimoni?websiteFor=carnivalcastle"
        );

        if (res.data?.success && Array.isArray(res.data.testimoni)) {
          // ✅ Filter only active + with videoId
          const filtered = res.data.testimoni.filter(
            (t) => t.status === "active" && t.videoId
          );

          // ✅ Map API fields to front-end fields
          const formatted = filtered.map((t) => ({
            name: t.name,
            location: t.role || "Customer",
            rating: Number(t.rating) || 5,
            description: t.description || "",
            image: `https://api.carnivalcastle.com/${t.image}`,
            avatar: `https://api.carnivalcastle.com/${t.profileImage}`, // using same image as avatar
            occasion: t.type === "Yes" ? "Special Celebration" : "",
          }));

          // ✅ Group into slides of 3 per slide
          const grouped = [];
          for (let i = 0; i < formatted.length; i += 3) {
            grouped.push(formatted.slice(i, i + 3));
          }

          setSlides(grouped);
        }
      } catch (err) {
        console.error("Error fetching testimonials:", err);
      }
    };

    fetchTestimonials();
  }, []);




  const [occasions, setOccasions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOccasions = async () => {
      try {
        const response = await axios.post(URLS.GetAllOccation, {});
        if (response.status === 200) {
          setOccasions(response.data?.occasions || []);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOccasions();
  }, []);




  const BaseUrl = "https://api.carnivalcastle.com/v1/carnivalApi/";
  const ImageBase = "https://api.carnivalcastle.com/";

  const [addresses, setAddresses] = useState([]);

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const res = await axios.get(`${BaseUrl}admin/address/alladdress`);
        if (res.data && res.data.success) {
          setAddresses(res.data.data || []);
        } else {
          setAddresses([]);
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
        setAddresses([]);
      }
    };
    fetchAddresses();
  }, []);


  const [lgShow, setLgShow] = useState(false);

  useEffect(() => {
    const isModalShown = localStorage.getItem("popupShown");
    if (!isModalShown) {
      setLgShow(true);
    }
  }, []);

  const handleClose = () => {
    setLgShow(false);
    localStorage.setItem("popupShown", "true");
  };

  const [banner, setBanner] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Fetch Banner Data
  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const res = await axios.get(
          "https://api.carnivalcastle.com/v1/carnivalApi/admin/get-banners?type=carnivalcastle"
        );
        if (res.data.success && res.data.banners.length > 0) {
          setBanner(res.data.banners[0]);
        }
      } catch (err) {
        console.error("Error fetching banner:", err);
      }
    };
    fetchBanner();
  }, []);

  // Auto-slide every 4 seconds
  useEffect(() => {
    if (!banner?.desktopImages?.length) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex + 1 >= banner.desktopImages.length ? 0 : prevIndex + 1
      );
    }, 3000);
    return () => clearInterval(interval);
  }, [banner]);

  if (!banner) return null;

  // Get current image
  const desktopImage1 = `https://api.carnivalcastle.com/${banner.desktopImages[currentIndex]}`;
  const mobileImage = `https://api.carnivalcastle.com/${banner.mobileImages[currentIndex]}`;

  // Manual navigation
  const prevSlide = () =>
    setCurrentIndex((prev) =>
      prev === 0 ? banner.desktopImages.length - 1 : prev - 1
    );
  const nextSlide = () =>
    setCurrentIndex((prev) =>
      prev + 1 >= banner.desktopImages.length ? 0 : prev + 1
    );


  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Carnival Castle | Best Private Theaters for Celebrations in Hyderabad
        </title>
        <meta
          name="description"
          content="Experience the magic of celebrations at Carnival Castle Private Theatres in Hyderabad. Perfect for Birthdays, Anniversaries, Bride To Be, Surprise Parties, etc"
        />
      </Helmet>

      {isLoading == true ? (
        <>
          <div
            className="text-center"
            style={{
              // background:
              //   "linear-gradient(329deg, rgba(191, 63, 249, 1) 0%, rgba(113, 51, 210, 1) 100%)",
              backgroundColor: "var(--charcoal-black)",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div>
              <img
                src="assets/img/giff.gif"
                style={{ height: "300px", color: "white" }}
              ></img>
              <h6 style={{ color: "gold" }}>Loading...</h6>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="home-page indexsix bg-dark">
            <div className="main-wrapper bg-light">
              <>
                <Header />
                <div className="scrollbar">
                  {/* <Time/> */}
                  <Slider {...settings}>
                    {/* Desktop images ko map karo */}
                    {banner?.desktopImages?.map((desktopImage, index) => (
                      <div key={index}>
                        <div className="mt-0">
                          {PopUp1.modalEnabled && (
                            <div style={{ backgroundColor: "#9D4DFF" }} className="text-center py-2">
                              <marquee className="text-white fw-bold">
                                {PopUp1.title}
                              </marquee>
                            </div>
                          )}
                        </div>
                        <section
                          className="banner-section d-flex align-items-center position-relative text-white overflow-hidden"
                          style={{
                            backgroundImage: `url(https://api.carnivalcastle.com/${desktopImage})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            height: "80vh",
                            transition: "background-image 1s ease-in-out",
                          }}
                        >
                          {/* Overlay */}
                          <div
                            className="overlay position-absolute w-100 h-100"
                            style={{
                              background: "rgba(0, 0, 0, 0.4)",
                              top: 0,
                              left: 0,
                              zIndex: 1,
                            }}
                          ></div>

                          {/* Content */}
                          <div className="container position-relative h-100" style={{ zIndex: 2 }}>
                            <div className="row justify-content-center text-center text-md-start h-100">
                              <div className="col-lg-10 d-flex flex-column justify-content-center h-100">
                                <h1 className="fw-bold mb-3 animate__animated animate__fadeInDown">
                                  {banner.title}
                                </h1>
                                <p className="lead mt-2 mb-4 animate__animated animate__fadeInUp">
                                  {banner.description}
                                </p>

                                <div className="banner-buttons d-flex flex-column flex-sm-row gap-3">
                                  <a
                                    href="/locations"
                                    className="btn btn-lg px-4 fw-bold btn-light"
                                  >
                                    Book Now
                                  </a>
                                  <a
                                    href="tel:8977917555"
                                    className="btn btn-lg px-4 fw-bold btn-light"
                                  >
                                    Book via Call
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>



                          {/* Slide Dots */}
                          <div
                            className="position-absolute w-100 d-flex justify-content-center gap-2"
                            style={{ bottom: "25px", zIndex: 3 }}
                          >
                            {banner.desktopImages.map((_, index) => (
                              <div
                                key={index}
                                onClick={() => setCurrentIndex(index)}
                                style={{
                                  width: currentIndex === index ? "12px" : "8px",
                                  height: currentIndex === index ? "12px" : "8px",
                                  borderRadius: "50%",
                                  background:
                                    currentIndex === index
                                      ? "#fff"
                                      : "rgba(255,255,255,0.5)",
                                  cursor: "pointer",
                                  transition: "all 0.3s ease",
                                }}
                              ></div>
                            ))}
                          </div>

                          {/* Mobile background override */}
                          <style>
                            {`
                              @media (max-width: 768px) {
                                .banner-section {
                                  background-image: url(${mobileImage}) !important;
                                }
                              }
                            `}
                          </style>
                        </section>

                      </div>
                    )
                    )}
                  </Slider>
                </div>

                {testimonials.length > 0 && (
                  <section
                    className="py-5 position-relative text-dark"
                    style={{ backgroundColor: "#fff", overflowX: "hidden" }}
                  >
                    <Container fluid="lg">
                      <Row className="flex-column align-items-center text-center">
                        {/* TITLE */}
                        <Col xs={12} className="mb-4">
                          <h2 className="fw-bold mt-3 dark-text">Testimonials</h2>
                          <p className="light-text fs-6">
                            Real stories. Real celebrations. Real magic at Binge N Joy.
                          </p>
                        </Col>

                        {/* SLIDER */}
                        <Col xs={12} className="d-flex justify-content-center position-relative">
                          <div
                            id="testimonial3DCarousel"
                            className="carousel slide carousel-fade position-relative"
                            data-bs-ride="false"
                          >
                            <div className="carousel-inner w-100">
                              {testimonials.map((item, index) => {
                                const prevIndex = index === 0 ? testimonials.length - 1 : index - 1;
                                const nextIndex = index === testimonials.length - 1 ? 0 : index + 1;

                                return (
                                  <div
                                    key={index}
                                    className={`carousel-item ${index === 0 ? "active" : ""}`}
                                  >
                                    <div className="d-flex justify-content-center align-items-center gap-3 px-3">
                                      {/* LEFT SMALL CARD - PREVIOUS TESTIMONIAL */}
                                      <div
                                        className="side-video small-card shadow rounded overflow-hidden d-none d-md-block"
                                        style={{
                                          width: "150px",
                                          height: "200px",
                                          backgroundImage: `url(${testimonials[prevIndex]?.profileImage
                                            ? testimonials[prevIndex]?.profileImage.replace(/\\/g, "/").startsWith("uploads/")
                                              ? `https://api.carnivalcastle.com/${testimonials[prevIndex]?.profileImage.replace(/\\/g, "/")}`
                                              : testimonials[prevIndex]?.profileImage
                                            : ""
                                            })`,

                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                          opacity: "0.7",
                                        }}
                                      >
                                        <div className="w-100 h-100 d-flex align-items-end justify-content-center p-2">
                                          <div className="bg-dark bg-opacity-75 text-white px-2 py-1 rounded small">
                                            {testimonials[prevIndex]?.name}
                                          </div>
                                        </div>
                                      </div>

                                      {/* MAIN VIDEO - CURRENT TESTIMONIAL */}
                                      <div
                                        className="main-video-card position-relative shadow rounded overflow-hidden"
                                        style={{ width: "400px" }}
                                      >
                                        <iframe
                                          width="100%"
                                          height="300"
                                          src={`https://www.youtube.com/embed/${item.videoId}?autoplay=1&mute=1&loop=0`}
                                          title={item.name}
                                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                          allowFullScreen
                                        ></iframe>

                                        <div className="label-card mt-3">
                                          <div className="bg-white px-3 py-2 rounded-4 shadow-sm text-center">
                                            <strong className="dark-text">{item.name}</strong>
                                            <br />
                                            <small className="text-dark">{item.role}</small>
                                          </div>
                                        </div>
                                      </div>

                                      {/* RIGHT SMALL CARD - NEXT TESTIMONIAL */}
                                      <div
                                        className="side-video small-card shadow rounded overflow-hidden d-none d-md-block"
                                        style={{
                                          width: "150px",
                                          height: "200px",
                                          backgroundImage: `url(${testimonials[nextIndex]?.profileImage?.replace(/\\/g, "/").startsWith("uploads/")
                                            ? `https://api.carnivalcastle.com/${testimonials[nextIndex]?.profileImage.replace(/\\/g, "/")}`
                                            : testimonials[nextIndex]?.profileImage
                                            })`,

                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                          opacity: "0.7",
                                        }}
                                      >
                                        <div className="w-100 h-100 d-flex align-items-end justify-content-center p-2">
                                          <div className="bg-dark bg-opacity-75 text-white px-2 py-1 rounded small">
                                            {testimonials[nextIndex]?.name}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>

                            {/* Desktop Indicators - Top position */}
                            <div className="carousel-indicators position-relative mt-4 d-none d-md-flex justify-content-center">
                              {testimonials.map((_, index) => (
                                <button
                                  key={index}
                                  type="button"
                                  data-bs-target="#testimonial3DCarousel"
                                  data-bs-slide-to={index}
                                  className={index === 0 ? "active" : ""}
                                  aria-current={index === 0 ? "true" : "false"}
                                  aria-label={`Slide ${index + 1}`}
                                ></button>
                              ))}
                            </div>

                            {/* Mobile Navigation Buttons - Bottom position */}
                            <div className="d-md-none mobile-navigation-buttons position-absolute w-100 d-flex justify-content-center align-items-center gap-3">
                              <button
                                className="mobile-nav-btn mobile-prev-btn bg-dark text-white border-0 rounded-circle d-flex align-items-center justify-content-center"
                                type="button"
                                data-bs-target="#testimonial3DCarousel"
                                data-bs-slide="prev"
                                aria-label="Previous testimonial"
                              >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                  <path d="M15 18l-6-6 6-6" />
                                </svg>
                              </button>

                              {/* Mobile Slide Indicators */}
                              <div className="d-flex align-items-center gap-2">
                                {testimonials.map((_, index) => (
                                  <button
                                    key={index}
                                    type="button"
                                    data-bs-target="#testimonial3DCarousel"
                                    data-bs-slide-to={index}
                                    className={`mobile-indicator-btn ${index === 0 ? "active" : ""}`}
                                    aria-label={`Go to slide ${index + 1}`}
                                  ></button>
                                ))}
                              </div>

                              <button
                                className="mobile-nav-btn mobile-next-btn bg-dark text-white border-0 rounded-circle d-flex align-items-center justify-content-center"
                                type="button"
                                data-bs-target="#testimonial3DCarousel"
                                data-bs-slide="next"
                                aria-label="Next testimonial"
                              >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                  <path d="M9 18l6-6-6-6" />
                                </svg>
                              </button>
                            </div>

                            {/* Desktop Controls */}
                            {/* <button
                              className="carousel-control-prev d-none d-md-flex"
                              type="button"
                              data-bs-target="#testimonial3DCarousel"
                              data-bs-slide="prev"
                            >
                              <span
                                className="carousel-control-prev-icon bg-dark rounded-circle p-2"
                                aria-hidden="true"
                              ></span>
                              <span className="visually-hidden">Previous</span>
                            </button>
                            <button
                              className="carousel-control-next d-none d-md-flex"
                              type="button"
                              data-bs-target="#testimonial3DCarousel"
                              data-bs-slide="next"
                            >
                              <span
                                className="carousel-control-next-icon bg-dark rounded-circle p-2"
                                aria-hidden="true"
                              ></span>
                              <span className="visually-hidden">Next</span>
                            </button> */}
                          </div>
                        </Col>
                      </Row>
                    </Container>

                    {/* CSS */}
                    <style jsx>{`
      #testimonial3DCarousel {
        margin: 0 auto;
        max-width: 900px;
        width: 100%;
        position: relative;
        padding-bottom: 80px; /* Space for mobile navigation */
      }

      .carousel-inner {
        text-align: center;
      }

      .carousel-item {
        transition: transform 0.6s ease-in-out;
      }

      .carousel-item.active .main-video-card {
        transform: scale(1.05);
        transition: transform 0.6s ease;
      }

      .carousel-item.active .side-video {
        opacity: 1 !important;
        transform: scale(0.9);
        transition: all 0.4s ease;
      }

      .main-video-card {
        transition: all 0.6s ease;
        z-index: 2;
        flex-shrink: 0;
      }

      .side-video {
        transition: all 0.4s ease;
        position: relative;
        cursor: pointer;
      }

      .side-video:hover {
        opacity: 0.9 !important;
        transform: scale(0.95);
      }

      /* Desktop Indicators */
      .carousel-indicators.position-relative {
        margin-top: 2rem;
      }

      .carousel-indicators.position-relative button {
        background-color: #dee2e6;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: none;
        margin: 0 5px;
        transition: all 0.3s ease;
      }

      .carousel-indicators.position-relative .active {
        background-color: #7b2cbf;
        width: 25px;
        border-radius: 10px;
      }

      /* Mobile Navigation Buttons */
      .mobile-navigation-buttons {
        bottom: 10px;
        left: 0;
        right: 0;
        padding: 0 20px;
        z-index: 10;
      }

      .mobile-nav-btn {
        width: 44px;
        height: 44px;
        background-color: #7b2cbf !important;
        border: none;
        cursor: pointer;
        transition: all 0.3s ease;
        flex-shrink: 0;
      }

      .mobile-nav-btn:hover {
        background-color: #6a1b9a !important;
        transform: scale(1.1);
      }

      .mobile-nav-btn:active {
        transform: scale(0.95);
      }

      .mobile-nav-btn svg {
        color: white;
      }

      /* Mobile Slide Indicators */
      .mobile-indicator-btn {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: none;
        background-color: #dee2e6;
        cursor: pointer;
        transition: all 0.3s ease;
        margin: 0 2px;
      }

      .mobile-indicator-btn.active {
        background-color: #7b2cbf;
        width: 25px;
        border-radius: 10px;
      }

      .mobile-indicator-btn:hover {
        background-color: #7b2cbf;
        transform: scale(1.2);
      }

      .carousel-control-prev,
      .carousel-control-next {
        width: auto;
        opacity: 1;
      }

      .carousel-control-prev {
        left: -50px;
      }

      .carousel-control-next {
        right: -50px;
      }

      /* Mobile-specific styles */
      @media (max-width: 1200px) {
        .carousel-control-prev {
          left: -30px;
        }
        .carousel-control-next {
          right: -30px;
        }
      }

      @media (max-width: 992px) {
        .main-video-card {
          width: 100% !important;
          max-width: 350px;
        }

        .side-video {
          display: none !important;
        }

        .carousel-control-prev {
          left: -20px;
        }
        .carousel-control-next {
          right: -20px;
        }

        #testimonial3DCarousel {
          padding-bottom: 70px;
        }

        .mobile-navigation-buttons {
          bottom: 5px;
        }
      }

      @media (max-width: 768px) {
        .mobile-nav-btn {
          width: 40px;
          height: 40px;
        }

        .mobile-indicator-btn {
          width: 8px;
          height: 8px;
        }

        .mobile-indicator-btn.active {
          width: 20px;
        }
      }

      @media (max-width: 576px) {
        .main-video-card iframe {
          height: 220px;
        }
        
        .carousel-control-prev,
        .carousel-control-next {
          display: none;
        }

        #testimonial3DCarousel {
          padding-bottom: 60px;
        }

        .mobile-navigation-buttons {
          bottom: 0;
          padding: 0 15px;
        }

        .mobile-nav-btn {
          width: 36px;
          height: 36px;
        }

        .mobile-indicator-btn {
          width: 7px;
          height: 7px;
        }

        .mobile-indicator-btn.active {
          width: 18px;
        }
      }

      @media (max-width: 400px) {
        .mobile-nav-btn {
          width: 32px;
          height: 32px;
        }

        .mobile-indicator-btn {
          width: 6px;
          height: 6px;
          margin: 0 1px;
        }

        .mobile-indicator-btn.active {
          width: 16px;
        }

        #testimonial3DCarousel {
          padding-bottom: 50px;
        }

        .mobile-navigation-buttons {
          gap: 2px;
        }
      }
    `}</style>
                  </section>
                )}







                <section
                  className="occasions-section py-5 text-dark"
                  style={{ backgroundColor: "#fff" }}
                >
                  <div className="container">
                    <h2 className="text-center mb-5 light-text">
                      What Can You Celebrate at Carnival Castle?
                    </h2>

                    <div
                      className="card text-white p-4 rounded-4 border-0"
                      style={{ backgroundColor: "#E9DCFF" }}
                    >
                      <Slider
                        dots={false}
                        infinite={true}
                        speed={500}
                        slidesToShow={3} // default for large screens
                        slidesToScroll={1} // scroll one card at a time
                        autoplay={true}
                        autoplaySpeed={3000}
                        responsive={[
                          {
                            breakpoint: 992, // medium devices
                            settings: {
                              slidesToShow: 2,
                              slidesToScroll: 1,
                            },
                          },
                          {
                            breakpoint: 768, // small devices
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1,
                            },
                          },
                        ]}
                      >
                        {occasions.map((occasion, index) => {
                          let description = "";
                          switch (occasion.name) {
                            case "Anniversary":
                              description =
                                "Celebrate your love and commitment in a private, luxurious theatre at CarnivalCastle. Enjoy a personalized ambiance, delicious food, and exceptional picture quality.";
                              break;
                            case "Bride To Be":
                              description =
                                "Celebrate your upcoming wedding with a special private screening. Enjoy a memorable day filled with personalized decor, scrumptious food, and a luxurious theatre experience.";
                              break;
                            case "Groom To Be":
                              description =
                                "Make the groom’s last night as a bachelor memorable with a private screening and special services. Enjoy delicious food, exceptional sound, and an intimate theatre experience.";
                              break;
                            case "Dad To Be":
                              description =
                                "Celebrate the soon-to-be father in a private, luxurious setting with custom decor and exceptional service. Enjoy great food, a perfect movie, and a memorable experience.";
                              break;
                            case "Mom To Be":
                              description =
                                "Celebrate the expecting mother in a private theatre with amazing decor and personalized services. Enjoy a relaxing, unforgettable experience with great food and movies.";
                              break;
                            case "Love Proposal":
                              description =
                                "Plan the perfect surprise proposal at CarnivalCastle Private Theatres. With a magical atmosphere, your proposal will be an unforgettable moment, complete with beautiful decor and food.";
                              break;
                            case "Marriage Proposal":
                              description =
                                "Propose in the most romantic and unforgettable way at CarnivalCastle. Enjoy a private theatre with personalized decor, delicious food, and everything you need for the perfect proposal.";
                              break;
                            case "Farewell":
                              description =
                                "Bid farewell in style at CarnivalCastle Private Theatres. Celebrate the memories with a private screening, delicious food, and the perfect ambiance for your farewell.";
                              break;
                            case "Bon voyage":
                              description =
                                "Send off a loved one with a special farewell event at CarnivalCastle Private Theatres. Enjoy a private screening with gourmet food and personalized decor for the perfect bon voyage.";
                              break;
                            default:
                              description =
                                "Carnival Castle Private Theatres is the perfect place to celebrate any special occasion. Enjoy an intimate and luxurious setting with exceptional picture and sound quality, delicious food, and attentive staff.";
                              break;
                          }

                          return (
                            <div key={index} className="px-2">
                              <div
                                className="card h-100 text-center bg-light rounded-4 gradient45 p-2"
                              >
                                <div className="card-body d-flex flex-column align-items-center" onClick={() => navigateTheater("/locations")}>
                                  <img
                                    src={URLS.Base + occasion.image}
                                    alt={occasion.name}
                                    className="rounded-5 mb-3 img-fluid"
                                    style={{
                                      height: "250px",
                                      width: "100%",
                                      objectFit: "cover",
                                      border: "2px solid #9D4DFF",
                                    }}
                                  />
                                  <h2 className="card-title fw-bold" style={{ color: "#681DC0" }}>
                                    {occasion.name === "Carnival Castle"
                                      ? "Carnival Castle"
                                      : occasion.name}
                                  </h2>
                                  {/* <p className="card-text small">{description}</p> */}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </Slider>

                      {/* Proceed Button */}
                      <div className="text-center">

                        {/* Proceed Button */}
                        <button
                          className="btn px-5 py-2 rounded-3 fw-bold light-back text-light mb-3"
                          style={{ width: "80%", maxWidth: "500px" }}
                          onClick={() => navigateTheater("/locations")}
                        >
                          Proceed to Book <i className="bi bi-arrow-right ms-2"></i>
                        </button>

                        {/* WhatsApp Chat Button */}
                        <div>
                          <a
                            href="https://wa.me/918374777834?text=Hello%2C%20I%20want%20to%20book%20tickets."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn px-5 py-1 rounded-3 fw-bold d-flex align-items-center justify-content-center gap-2"
                            style={{
                              width: "80%",
                              maxWidth: "500px",
                              background: "#25D366",
                              color: "#fff",
                              margin: "0 auto"
                            }}
                          >
                            <i className="bi bi-whatsapp fs-5"></i>
                            Chat With Us
                          </a>
                        </div>

                      </div>
                    </div>
                  </div>
                  <style jsx>{`
                  /* slider indicators */
.slick-dots {
  bottom: -35px;
}

.slick-dots li button:before {
  font-size: 10px;
  color: #ccc; /* inactive color */
  opacity: 1;
}

.slick-dots li.slick-active button:before {
  color: #681DC0; /* active dot color */
}
  `}</style>
                </section>

                <section className="services-section py-2 text-dark bg-white">
                  <div className="container">
                    <h2 className="text-center dark-text fw-bold">Our Services</h2>

                    {/* Large Card Wrapper */}
                    <div className="card text-dark p-4 rounded-4 border-0" style={{ backgroundColor: "#fff" }}>

                      {/* Carousel for Mobile/Tablet */}
                      <div
                        id="servicesCarousel"
                        className="carousel slide d-xl-none"
                        data-bs-ride="carousel"
                        data-bs-interval="3000"
                      >
                        <div className="carousel-inner">
                          {/* Slide 1 - Food & Beverages */}
                          <div className="carousel-item active">
                            <div className="row g-4 justify-content-center">
                              <div className="col-12 col-md-6">
                                <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
                                  <div className="card-body d-flex flex-column align-items-center">
                                    <img
                                      src={beverages}
                                      alt="Food & Beverages"
                                      className="rounded mb-3"
                                      style={{
                                        height: "200px",
                                        width: "100%",
                                        objectFit: "cover",
                                        border: "2px solid"
                                      }}
                                    />
                                    <h5 className="card-title light-text">Food & Beverages</h5>
                                    <p className="card-text">Choose the perfect food combo for your celebration.</p>
                                    <a href="/Food" className="mt-auto light-text">
                                      View more <i className="fas fa-arrow-right"></i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Slide 2 - Screening */}
                          <div className="carousel-item">
                            <div className="row g-4 justify-content-center">
                              <div className="col-12 col-md-6">
                                <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
                                  <div className="card-body d-flex flex-column align-items-center">
                                    <img
                                      src={cake4}
                                      alt="Cakes"
                                      className="rounded mb-3"
                                      style={{
                                        height: "200px",
                                        width: "100%",
                                        objectFit: "cover",
                                        border: "2px solid #E9BE5F"
                                      }}
                                    />
                                    <h5 className="card-title light-text">Cakes</h5>
                                    <p className="card-text">Choose the perfect cake for your celebration from our selection.</p>
                                    <a href="/cakes" className="mt-auto light-text">
                                      View more <i className="fas fa-arrow-right"></i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Slide 3 - Cakes */}
                          <div className="carousel-item">
                            <div className="row g-4 justify-content-center">
                              <div className="col-12 col-md-6">
                                <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
                                  <div className="card-body d-flex flex-column align-items-center">
                                    <img
                                      src={screening}
                                      alt="Screening"
                                      className="rounded mb-3"
                                      style={{
                                        height: "200px",
                                        width: "100%",
                                        objectFit: "cover",
                                        border: "2px solid #E9BE5F"
                                      }}
                                    />
                                    <h5 className="card-title light-text">Screening</h5>
                                    <p className="card-text">Bring your OTT accounts and relive the theatre magic!</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Slide 4 - Bouquets */}
                          <div className="carousel-item">
                            <div className="row g-4 justify-content-center">
                              <div className="col-12 col-md-6">
                                <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
                                  <div className="card-body d-flex flex-column align-items-center">
                                    <img
                                      src={roses}
                                      alt="Bouquets"
                                      className="rounded mb-3"
                                      style={{
                                        height: "200px",
                                        width: "100%",
                                        objectFit: "cover",
                                        border: "2px solid #E9BE5F"
                                      }}
                                    />
                                    <h5 className="card-title light-text">Bouquets</h5>
                                    <p className="card-text">Add a beautiful rose bouquet to enhance your celebration.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Carousel Controls */}
                        <button className="carousel-control-prev" type="button" data-bs-target="#servicesCarousel" data-bs-slide="prev">
                          <span className="carousel-control-prev-icon" aria-hidden="true" style={{ backgroundColor: '', borderRadius: '50%', padding: '15px' }}></span>
                          <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#servicesCarousel" data-bs-slide="next">
                          <span className="carousel-control-next-icon" aria-hidden="true" style={{ backgroundColor: '', borderRadius: '50%', padding: '15px' }}></span>
                          <span className="visually-hidden">Next</span>
                        </button>

                        {/* Carousel Indicators */}
                        <div className="carousel-indicators position-relative mt-3">
                          <button type="button" data-bs-target="#servicesCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1" style={{ backgroundColor: '#800080', width: '10px', height: '10px', borderRadius: '50%', margin: '0 5px' }}></button>
                          <button type="button" data-bs-target="#servicesCarousel" data-bs-slide-to="1" aria-label="Slide 2" style={{ backgroundColor: '#800080', width: '10px', height: '10px', borderRadius: '50%', margin: '0 5px' }}></button>
                          <button type="button" data-bs-target="#servicesCarousel" data-bs-slide-to="2" aria-label="Slide 3" style={{ backgroundColor: '#800080', width: '10px', height: '10px', borderRadius: '50%', margin: '0 5px' }}></button>
                          <button type="button" data-bs-target="#servicesCarousel" data-bs-slide-to="3" aria-label="Slide 4" style={{ backgroundColor: '#800080', width: '10px', height: '10px', borderRadius: '50%', margin: '0 5px' }}></button>
                        </div>
                      </div>

                      {/* Desktop Grid - 4 cards in a row (Visible only on large screens) */}
                      <div className="row g-4 d-none d-xl-flex gradient45 p-3 rounded-3">
                        {/* Service Card 1 */}
                        <div className="col-12 col-sm-6 col-lg-3">
                          <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
                            <div className="card-body d-flex flex-column align-items-center">
                              <img
                                src={beverages}
                                alt="Food & Beverages"
                                className="rounded mb-3"
                                style={{
                                  height: "200px",
                                  width: "100%",
                                  objectFit: "cover",
                                  border: "2px solid #E9BE5F"
                                }}
                              />
                              <h5 className="card-title light-text">Food & Beverages</h5>
                              <p className="card-text">Choose the perfect food combo for your celebration.</p>
                              <a href="/Food" className="mt-auto light-text">
                                View more <i className="fas fa-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>

                        {/* Service Card 2 */}
                        <div className="col-12 col-sm-6 col-lg-3">
                          <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
                            <div className="card-body d-flex flex-column align-items-center">
                              <img
                                src={cake4}
                                alt="Cakes"
                                className="rounded mb-3"
                                style={{
                                  height: "200px",
                                  width: "100%",
                                  objectFit: "cover",
                                  border: "2px solid #E9BE5F"
                                }}
                              />
                              <h5 className="card-title light-text">Cakes</h5>
                              <p className="card-text">Choose the perfect cake for your celebration from our selection.</p>
                              <a href="/cakes" className="mt-auto light-text">
                                View more <i className="fas fa-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>

                        {/* Service Card 3 */}
                        <div className="col-12 col-sm-6 col-lg-3">
                          <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
                            <div className="card-body d-flex flex-column align-items-center">
                              <img
                                src={screening}
                                alt="Screening"
                                className="rounded mb-3"
                                style={{
                                  height: "200px",
                                  width: "100%",
                                  objectFit: "cover",
                                  border: "2px solid #E9BE5F"
                                }}
                              />
                              <h5 className="card-title light-text">Screening</h5>
                              <p className="card-text">Bring your OTT accounts and relive the theatre magic!</p>
                            </div>
                          </div>
                        </div>

                        {/* Service Card 4 */}
                        <div className="col-12 col-sm-6 col-lg-3">
                          <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
                            <div className="card-body d-flex flex-column align-items-center">
                              <img
                                src={roses}
                                alt="Bouquets"
                                className="rounded mb-3"
                                style={{
                                  height: "200px",
                                  width: "100%",
                                  objectFit: "cover",
                                  border: "2px solid #E9BE5F"
                                }}
                              />
                              <h5 className="card-title light-text">Bouquets</h5>
                              <p className="card-text">Add a beautiful rose bouquet to enhance your celebration.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-center mt-1">
                      <a
                        href="https://wa.me/918374777834?text=Hello%2C%20I%20want%20to%20book%20tickets."
                        target="_blank"
                        rel="noopener noreferrer"
                        className="chat-btn d-inline-flex align-items-center justify-content-center gap-2"
                      >
                        <i className="bi bi-whatsapp"></i>
                        Chat With Us
                      </a>
                    </div>
                  </div>

                  <style jsx>{`

                  .chat-btn {
  background: #25D366;
  color: white;
  font-weight: 600;
  padding: 10px 22px;
  border-radius: 30px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.chat-btn i {
  font-size: 18px;
}

.chat-btn:hover {
  background: #1ebe5d;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}
    /* Carousel Styles */
    .carousel-control-prev,
    .carousel-control-next {
      width: 40px;
      height: 40px;
      top: 50%;
      transform: translateY(-50%);
      opacity: 1;
    }

    .carousel-control-prev {
      left: -20px;
    }

    .carousel-control-next {
      right: -20px;
    }

    .carousel-indicators {
      bottom: -30px;
    }

    .carousel-indicators button {
      border: none;
    }

    /* Gradient Background for Cards */
    .gradient45 {
      background: linear-gradient(145deg, #ffffff 0%, #f8f8f8 100%);
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .gradient45:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 20px rgba(0,0,0,0.15) !important;
    }

    /* Responsive breakpoints */
    @media (max-width: 575px) {
      /* Mobile: 1 card */
      .carousel-control-prev {
        left: -5px;
      }
      .carousel-control-next {
        right: -5px;
      }
      .carousel-control-prev span,
      .carousel-control-next span {
        padding: 8px !important;
      }
      .col-12 {
        max-width: 100%;
        flex: 0 0 100%;
      }
    }

    @media (min-width: 576px) and (max-width: 1199px) {
      /* Tablet/Medium: 2 cards */
      .carousel-control-prev {
        left: -10px;
      }
      .carousel-control-next {
        right: -10px;
      }
      .col-md-6 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }

    @media (min-width: 1200px) {
      /* Large screens: 4 cards */
      .carousel {
        display: none !important;
      }
      .d-xl-flex {
        display: flex !important;
      }
      .gradient45 {
        min-height: 350px;
      }
    }

    /* Light text color */
    .light-text {
      color: #800080;
      font-weight: 600;
    }

    .light-text:hover {
      color: #40008C;
      text-decoration: underline;
    }

    /* Dark text color */
    .dark-text {
      color: #333;
    }

    /* Card text styling */
    .card-text {
      font-size: 14px;
      color: #666;
      margin: 10px 0;
    }

    .card-title {
      font-size: 18px;
      margin: 10px 0;
    }

    /* Ensure cards have equal height */
    .card.h-100 {
      display: flex;
      flex-direction: column;
    }

    .card-body {
      flex: 1;
    }

    /* Center content on mobile/tablet */
    .justify-content-center {
      justify-content: center !important;
    }
  `}</style>
                </section>

                {/* WHY US Section - Premium Design */}
                <section className="why-us-section position-relative" style={{
                  background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
                  padding: '80px 0',
                  overflow: 'hidden'
                }}>
                  {/* Decorative Background Elements */}
                  <div className="position-absolute" style={{
                    top: '-50px',
                    right: '-50px',
                    width: '200px',
                    height: '200px',
                    background: 'radial-gradient(circle, rgba(104,29,192,0.05) 0%, rgba(104,29,192,0) 70%)',
                    borderRadius: '50%',
                    zIndex: 0
                  }}></div>
                  <div className="position-absolute" style={{
                    bottom: '-30px',
                    left: '-30px',
                    width: '150px',
                    height: '150px',
                    background: 'radial-gradient(circle, rgba(255,193,7,0.05) 0%, rgba(255,193,7,0) 70%)',
                    borderRadius: '50%',
                    zIndex: 0
                  }}></div>

                  <Container className="position-relative" style={{ zIndex: 2 }}>
                    {/* Section Header with Premium Styling */}
                    <div className="text-center mb-5">
                      {/* <span className="badge bg-warning bg-opacity-15 text-warning px-4 py-2 mb-3 rounded-pill fw-semibold"
                        style={{
                          background: 'rgba(255, 193, 7, 0.15)',
                          letterSpacing: '1px',
                          fontSize: '0.9rem'
                        }}>
                        WHY CHOOSE US
                      </span> */}
                      <h3 className="display-4 fw-bold" style={{
                        color: '#1a1a1a',
                        fontSize: 'clamp(2rem, 5vw, 3.5rem)',
                        lineHeight: '1.2'
                      }}>
                        Plan a Suprise to your <span style={{ color: '#681DC0' }}>Loved one</span>
                      </h3>
                      {/* <p className="text-secondary mt-3" style={{
                        fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                        maxWidth: '700px',
                        margin: '0 auto'
                      }}>
                        Discover what makes us the preferred choice for unforgettable moments
                      </p> */}
                    </div>

                    {/* Main Content Card with Premium Design */}
                    <div className="why-us-card position-relative gradient45" style={{
                      // background: 'rgba(255, 255, 255, 0.95)',
                      backdropFilter: 'blur(10px)',
                      borderRadius: '40px',
                      padding: 'clamp(30px, 5vw, 60px)',
                      boxShadow: '0 30px 60px rgba(0,0,0,0.1), 0 10px 30px rgba(104,29,192,0.1)',
                      border: '1px solid rgba(255,255,255,0.5)',
                      transition: 'all 0.3s ease'
                    }}>

                      {/* Current Slide Content */}
                      <div className="slide-content">
                        <Row className="align-items-center g-5">
                          {/* Left Side - Image with Premium Effects */}
                          <Col lg={6} className="text-center text-lg-start">
                            <div className="position-relative">
                              {/* Image with gradient overlay */}
                              <div className="image-wrapper position-relative" style={{
                                borderRadius: '30px',
                                overflow: 'hidden',
                                boxShadow: '0 20px 40px rgba(104,29,192,0.2)',
                                transform: 'perspective(1000px) rotateY(-2deg)',
                                transition: 'transform 0.5s ease'
                              }}>
                                <img
                                  src={whyUsSlides[index].image}
                                  alt="Premium Experience"
                                  className="img-fluid w-100"
                                  style={{
                                    height: 'clamp(300px, 40vw, 500px)',
                                    objectFit: 'cover',
                                    transition: 'transform 0.5s ease'
                                  }}
                                />
                                {/* Gradient Overlay */}
                                <div className="position-absolute top-0 start-0 w-100 h-100" style={{
                                  background: 'linear-gradient(45deg, rgba(104,29,192,0.2) 0%, rgba(255,193,7,0.2) 100%)',
                                  mixBlendMode: 'overlay'
                                }}></div>
                              </div>

                              {/* Decorative Elements */}
                              <div className="position-absolute" style={{
                                bottom: '-20px',
                                right: '-20px',
                                width: '80px',
                                height: '80px',
                                background: 'linear-gradient(135deg, #681DC0, #ffc107)',
                                borderRadius: '20px',
                                transform: 'rotate(45deg)',
                                zIndex: -1,
                                opacity: 0.3
                              }}></div>
                            </div>
                          </Col>

                          {/* Right Side - Text Content */}
                          <Col lg={6}>
                            <div className="ps-lg-4">
                              {/* Title with Animation */}
                              <h3 className="fw-bold mb-4" style={{
                                color: '#4a4242',
                                position: 'relative',
                                paddingBottom: '15px'
                              }}>
                                {whyUsSlides[index].subtitle}
                                <span style={{
                                  position: 'absolute',
                                  bottom: 0,
                                  left: 0,
                                  width: '80px',
                                  height: '4px',
                                  background: 'linear-gradient(90deg, #681DC0, #ffc107)',
                                  borderRadius: '2px'
                                }}></span>
                              </h3>

                              {/* Points with Icons */}
                              <ul className="list-unstyled mt-4">
                                {whyUsSlides[index].points.map((point, i) => (
                                  <li key={i} className="mb-4 d-flex align-items-start">
                                    <div className="me-3" style={{
                                      width: '32px',
                                      height: '32px',
                                      background: 'linear-gradient(135deg, rgba(104,29,192,0.1), rgba(255,193,7,0.1))',
                                      borderRadius: '10px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      color: '#681DC0'
                                    }}>
                                      <i className="fas fa-check-circle" style={{ fontSize: '1.2rem' }}></i>
                                    </div>
                                    <div>
                                      <span style={{
                                        fontSize: 'clamp(1rem, 2vw, 1.1rem)',
                                        color: '#4a4a4a',
                                        lineHeight: '1.6'
                                      }}>
                                        {point}
                                      </span>
                                    </div>
                                  </li>
                                ))}
                              </ul>

                              {/* CTA Button with Premium Style */}
                              <div className="mt-5 d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 px-3">

                                {/* Book Button */}
                                <Button
                                  onClick={() => window.location.href = "/locations"}
                                  className="responsive-btn position-relative overflow-hidden"
                                >
                                  <i className="fas fa-ticket-alt me-2"></i>
                                  Book Your Experience
                                </Button>

                                {/* WhatsApp Button */}
                                <a
                                  href="https://wa.me/918374777834?text=Hello%2C%20I%20want%20to%20book%20tickets."
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="responsive-btn whatsapp-btn text-center text-decoration-none"
                                >
                                  <i className="bi bi-whatsapp me-2"></i>
                                 Chat With Us
                                </a>

                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      {/* Navigation Controls - Premium Design */}
                      <div className="navigation-controls d-flex justify-content-between align-items-center mt-5 pt-4">
                        {/* Arrow Navigation */}
                        {/* <div className="d-flex gap-3">
                          <button
                            onClick={() => handleSelect(index === 0 ? whyUsSlides.length - 1 : index - 1)}
                            className="nav-arrow prev-arrow"
                            style={{
                              width: '50px',
                              height: '50px',
                              borderRadius: '15px',
                              background: '#fff',
                              border: '1px solid rgba(104,29,192,0.2)',
                              color: '#681DC0',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '1.2rem',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = '#681DC0';
                              e.target.style.color = '#fff';
                              e.target.style.transform = 'scale(1.05)';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = '#fff';
                              e.target.style.color = '#681DC0';
                              e.target.style.transform = 'scale(1)';
                            }}
                          >
                            <i className="fas fa-arrow-left"></i>
                          </button>
                          <button
                            onClick={() => handleSelect(index === whyUsSlides.length - 1 ? 0 : index + 1)}
                            className="nav-arrow next-arrow"
                            style={{
                              width: '50px',
                              height: '50px',
                              borderRadius: '15px',
                              background: '#fff',
                              border: '1px solid rgba(104,29,192,0.2)',
                              color: '#681DC0',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '1.2rem',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = '#681DC0';
                              e.target.style.color = '#fff';
                              e.target.style.transform = 'scale(1.05)';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = '#fff';
                              e.target.style.color = '#681DC0';
                              e.target.style.transform = 'scale(1)';
                            }}
                          >
                            <i className="fas fa-arrow-right"></i>
                          </button>
                        </div> */}

                        {/* Slide Indicators */}
                        <div className="d-flex gap-2">
                          {whyUsSlides.map((_, i) => (
                            <button
                              key={i}
                              onClick={() => handleSelect(i)}
                              className="slide-indicator"
                              style={{
                                width: i === index ? '40px' : '12px',
                                height: '12px',
                                borderRadius: '20px',
                                border: 'none',
                                background: i === index
                                  ? 'linear-gradient(90deg, #681DC0, #ffc107)'
                                  : 'rgba(104,29,192,0.2)',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                boxShadow: i === index ? '0 5px 15px rgba(104,29,192,0.3)' : 'none'
                              }}
                              onMouseEnter={(e) => {
                                if (i !== index) {
                                  e.target.style.background = 'rgba(104,29,192,0.4)';
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (i !== index) {
                                  e.target.style.background = 'rgba(104,29,192,0.2)';
                                }
                              }}
                            />
                          ))}
                        </div>

                        {/* Slide Counter */}
                        {/* <div className="slide-counter" style={{
                          background: 'rgba(104,29,192,0.05)',
                          padding: '8px 20px',
                          borderRadius: '50px',
                          color: '#681DC0',
                          fontWeight: '600',
                          fontSize: '1rem',
                          letterSpacing: '1px'
                        }}>
                          <span style={{ fontSize: '1.3rem', fontWeight: '700' }}>{String(index + 1).padStart(2, '0')}</span>
                          <span style={{ color: '#999', margin: '0 5px' }}>/</span>
                          <span style={{ color: '#999' }}>{String(whyUsSlides.length).padStart(2, '0')}</span>
                        </div> */}
                      </div>
                    </div>
                  </Container>

                  {/* Premium Responsive Styles */}
                  <style jsx>{`
                      .why-us-section {
                        min-height: 70vh;
                        display: flex;
                        align-items: center;
                      }

                      /* Tablet Styles */
                      @media (max-width: 991px) {
                        .why-us-section {
                          padding: 60px 0;
                        }

                        .why-us-section .why-us-card {
                          padding: 30px !important;
                        }

                        .why-us-section .navigation-controls {
                          flex-wrap: wrap;
                          gap: 20px;
                          justify-content: center !important;
                        }

                        .why-us-section .slide-counter {
                          order: 1;
                        }

                        .why-us-section .d-flex.gap-3 {
                          order: 2;
                        }

                        .why-us-section .d-flex.gap-2 {
                          order: 3;
                        }
                      }

                      /* Mobile Styles */
                      @media (max-width: 576px) {
                        .why-us-section {
                          padding: 40px 0;
                        }

                        .why-us-section .why-us-card {
                          padding: 20px !important;
                          border-radius: 30px !important;
                        }

                        .why-us-section .image-wrapper {
                          transform: none !important;
                          box-shadow: 0 15px 30px rgba(104,29,192,0.15) !important;
                        }

                        .why-us-section .nav-arrow {
                          width: 45px !important;
                          height: 45px !important;
                          border-radius: 12px !important;
                        }

                        .why-us-section .slide-indicator {
                          height: 10px !important;
                        }

                        .why-us-section .slide-indicator[style*="width: 40px"] {
                          width: 30px !important;
                        }

                        .why-us-section .badge {
                          font-size: 0.8rem !important;
                          padding: 6px 16px !important;
                        }

                        .why-us-section button {
                          width: 100%;
                          padding: 14px 20px !important;
                          font-size: 1rem !important;
                        }
                      }

                      /* Small Mobile Styles */
                      @media (max-width: 375px) {
                        .why-us-section .why-us-card {
                          padding: 15px !important;
                        }

                        .why-us-section h3 {
                          font-size: 1.3rem !important;
                        }

                        .why-us-section .navigation-controls {
                          flex-direction: column;
                        }
                      }

                      /* Hover Effects for Desktop */
                      @media (min-width: 992px) {
                        .why-us-section .image-wrapper:hover {
                          transform: perspective(1000px) rotateY(-4deg) scale(1.02) !important;
                        }

                        .why-us-section .why-us-card:hover {
                          box-shadow: 0 40px 80px rgba(104,29,192,0.15) !important;
                        }
                      }

                      .responsive-btn {
                      max-width: 420px;
                      padding: 16px 28px;
                      font-size: 1rem;
                      font-weight: 600;
                      border-radius: 50px;
                      text-transform: uppercase;
                      letter-spacing: 1px;
                      transition: all 0.3s ease;
                    }

                    /* Book Button */
                    .responsive-btn.btn {
                      background: linear-gradient(135deg, #681DC0, #8a4fe3);
                      border: none;
                      color: white;
                      box-shadow: 0 10px 20px rgba(104,29,192,0.3);
                    }

                    .responsive-btn.btn:hover {
                      transform: translateY(-2px);
                      box-shadow: 0 15px 30px rgba(104,29,192,0.4);
                    }

                    /* WhatsApp Button */
                    .whatsapp-btn {
                      background: #25D366;
                      color: white;
                      box-shadow: 0 10px 20px rgba(37,211,102,0.35);
                    }

                    .whatsapp-btn:hover {
                      transform: translateY(-2px);
                      box-shadow: 0 15px 30px rgba(37,211,102,0.45);
                    }

                    /* Mobile */
                    @media (max-width: 576px) {
                      .responsive-btn {
                        font-size: 0.9rem;
                        padding: 14px 20px;
                      }
                    }
                    `}</style>
                </section>

                {slides && slides.length > 0 && (
                  <section className="py-5 bg-white position-relative">
                    <Container>
                      <h2 className="text-center fw-bold mb-3 dark-text">
                        What Our Customers Say
                      </h2>

                      <p className="text-center mb-5 fs-5 light-text">
                        Real stories. Real celebrations. Real magic at Carnival Castle.
                      </p>

                      <Carousel controls interval={5000} pause="hover" fade={false} wrap>
                        {slides.map((group, idx) => (
                          <Carousel.Item key={idx}>
                            <Row className="g-4 justify-content-center">
                              {group.map((review, index) => (
                                <Col lg={4} md={6} sm={12} key={index}>
                                  <div
                                    className="review-card position-relative rounded-4 overflow-hidden shadow mb-4"
                                    style={{ height: "400px" }}
                                  >
                                    <img
                                      src={review.image}
                                      alt="Review background"
                                      className="w-100 h-100 object-fit-cover"
                                      style={{ filter: "brightness(70%)" }}
                                    />

                                    {/* Bottom overlay card */}
                                    <div
                                      className="position-absolute bottom-0 start-50 translate-middle-x p-4 rounded-top-4"
                                      style={{
                                        height: "auto",
                                        minHeight: "45%",
                                        width: "90%",
                                        backgroundColor: "rgba(233, 220, 255, 0.95)",
                                        backdropFilter: "blur(4px)",
                                      }}
                                    >
                                      <div className="d-flex align-items-center mb-3">
                                        <img
                                          src={review.avatar}
                                          alt="avatar"
                                          className="rounded-circle me-3 border-2 border-light"
                                          width="60"
                                          height="60"
                                        />
                                        <div>
                                          <h6 className="mb-0 fw-bold text-dark">
                                            {review.name}
                                          </h6>
                                          <small className="text-dark">
                                            {review.location}
                                          </small>
                                        </div>
                                      </div>

                                      <div className="text-warning mb-2 fs-5">
                                        {"★".repeat(review.rating)}
                                        {"☆".repeat(5 - review.rating)}
                                      </div>

                                      <p
                                        className="mb-2 text-dark"
                                        style={{ fontSize: "0.9rem" }}
                                      >
                                        {review.description}
                                      </p>

                                      {review.occasion && (
                                        <p
                                          className="mb-0 text-dark"
                                          style={{ fontSize: "0.85rem" }}
                                        >
                                          <strong>Occasion:</strong> {review.occasion}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </Carousel.Item>
                        ))}
                      </Carousel>
                    </Container>
                  </section>
                )}



                {/* Gallery */}
                <section className="pb-3 gradient45">
                  <div className="container-md">
                    <div className="section-wraper row d-flex align-items-center justify-content-center">
                      <div className="col-md-12 section-header mb-0 mt-3">
                        <h2 className="text-center fw-bold mb-3 dark-text">Gallery</h2>
                        <p className="text-center mb-5 fs-5 light-text">See how our guests made memories at Carnival Castle.</p>
                      </div>

                      <div className="row align-items-center justify-content-center">
                        <div className="container-md">
                          <div>
                            <Galleria
                              ref={galleria}
                              value={images}
                              numVisible={7}
                              style={{ maxWidth: "850px" }}
                              activeIndex={activeIndex}
                              onItemChange={(e) => setActiveIndex(e.index)}
                              circular
                              fullScreen
                              showItemNavigators
                              showThumbnails={false}
                              item={itemTemplate}
                              thumbnail={thumbnailTemplate}
                            />
                            <div>
                              <div className="row mb-2">
                                {images.map((image, index) => {
                                  return (
                                    <div
                                      className="col-lg-4 col-md-4 col-sm-6 col-12 mt-3 mb-4"
                                      key={index}
                                    >
                                      <div
                                        className="zoom-container gallery-img-wrapper"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          setActiveIndex(index);
                                          galleria.current.show();
                                        }}
                                      >
                                        <img
                                          src={URLS.Base + image.image}
                                          alt={image.alt}
                                          className="img-fluid gallery-img"
                                        />

                                        {/* Zoom Icon */}
                                        <span className="zoom-icon">
                                          <i className="fas fa-search-plus"></i>
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* View All Button - Centered at Bottom */}
                      <div className="col-md-12 text-center mt-3 mb-4 d-flex flex-column flex-md-row justify-content-center align-items-center gap-3">

                        {/* View Gallery Button */}
                        <a
                          href="/gallery"
                          className="btn light-back fw-bold dark-back responsive-btn"
                        >
                          View Gallery <i className="bi bi-arrow-right ms-2"></i>
                        </a>

                        {/* WhatsApp Button */}
                        <a
                          href="https://wa.me/918374777834?text=Hello%2C%20I%20want%20to%20book%20tickets."
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn whatsapp-btn fw-bold responsive-btn"
                        >
                          <i className="bi bi-whatsapp me-2"></i>
                         Chat With Us
                        </a>

                      </div>
                    </div>
                  </div>
                  <style>
                    {`
                    .gallery-img-wrapper{
                      width:100%;
                      height:400px;
                      overflow:hidden;
                      position:relative;
                      border:1px solid #F5E7B6;
                    }

                    .gallery-img{
                      width:100%;
                      height:100%;
                      object-fit:cover;
                      transition:transform 0.4s ease;
                    }

                    .gallery-img-wrapper:hover .gallery-img{
                      transform:scale(1.08);
                    }

                    /* Zoom Icon */
                    .zoom-icon{
                      position:absolute;
                      top:50%;
                      left:50%;
                      transform:translate(-50%,-50%);
                      background:rgba(0,0,0,0.5);
                      color:#fff;
                      padding:10px 12px;
                      border-radius:50%;
                      opacity:0;
                      transition:0.3s;
                    }

                    .gallery-img-wrapper:hover .zoom-icon{
                      opacity:1;
                    }
                    .responsive-btn {
                      padding: 12px 26px;
                      border-radius: 40px;
                      font-size: 0.95rem;
                      letter-spacing: 0.5px;
                    }

                    .whatsapp-btn {
                      background: #25D366 !important;
                      color: #fff;
                      border: none;
                    }

                    .whatsapp-btn:hover {
                      background: #1ebe5d;
                      color: #fff;
                    }
                    `}
                  </style>
                </section>


                {/* <section className="py-5 bg-light">
                  <div className="container">
                    <div className="text-center mb-5">
                      <h2 className="display-5 fw-bold dark-text">Our Packages</h2>
                      <p className="fs-5 light-text">
                        <i>Choose Wisely</i>
                      </p>
                    </div>

                    
                    <div className="row g-4 justify-content-center d-none d-md-flex">
                      {packages.map((pkg) => (
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-10" key={pkg.id}>
                          <div className="card border-0 shadow rounded-4 h-100 text-center gradient45 position-relative">
                            <div className="card-body d-flex flex-column p-4">
                             
                              <div className="mb-3">
                                <h4 className="fw-bold mb-1">{pkg.title}</h4>
                                <p
                                  className="text-muted mb-0"
                                  style={{ fontStyle: "italic", fontSize: "14px" }}
                                >
                                  {pkg.subtitle}
                                </p>
                              </div>

                             
                              <ul className="list-unstyled text-start flex-grow-1 mb-0 px-2">
                                {(showMore
                                  ? Object.keys(pkg.detailedFeatures).slice(0, 7)
                                  : Object.keys(pkg.detailedFeatures)
                                ).map((feature, idx) => (
                                  <li key={idx} className="d-flex align-items-center mb-2">
                                    <span
                                      className={`me-2 fw-bold ${pkg.detailedFeatures[feature] ? "text-success" : "text-danger"
                                        }`}
                                    >
                                      {pkg.detailedFeatures[feature] ? "✅" : "❌"}
                                    </span>
                                    <span className="text-dark">{feature}</span>
                                  </li>
                                ))}
                              </ul>


                              {Object.keys(pkg.detailedFeatures).length > 7 && (
                                <button
                                  className="btn btn-link p-0 my-1 fw-bold"
                                  onClick={() => setShowMore(!showMore)}
                                >
                                  {showMore[pkg.id]
                                    ? "View Less"
                                    : `View More`}
                                </button>
                              )}


                       
                              {pkg?.price ? (
                                <p className="fw-semibold mb-4 mt-auto">
                                  Starts from ₹{pkg.price}
                                </p>
                              ) : null}

                         
                              <button
                                className="btn text-white w-100"
                                style={{ backgroundColor: "#a259ff", borderRadius: "10px" }}
                                onClick={() => navigateTheater("/locations")}
                              >
                                {pkg.buttonText}
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    
                    <div
                      id="packagesCarousel"
                      className=" slide d-block d-md-none"
                      data-bs-ride="carousel"
                      data-bs-interval="3000"
                      data-bs-wrap="true"
                      data-bs-pause="false"
                    >
                     
                      <div className="carousel-indicators">
                        {packages.map((_, index) => (
                          <button
                            key={index}
                            type="button"
                            data-bs-target="#packagesCarousel"
                            data-bs-slide-to={index}
                            className={index === 0 ? "active" : ""}
                            aria-current={index === 0 ? "true" : "false"}
                            aria-label={`Slide ${index + 1}`}
                          ></button>
                        ))}
                      </div>

               
                      <div className="carousel-inner">
                        {packages.map((pkg, index) => (
                          <div
                            className={`carousel-item ${index === 0 ? "active" : ""}`}
                            key={pkg.id}
                          >
                            <div className="d-flex justify-content-center">
                              <div className="col-10">
                                <div className="card border-0 shadow rounded-4 text-center gradient45">
                                  <div className="card-body d-flex flex-column p-4">
                     
                                    <div className="mb-3">
                                      <h4 className="fw-bold mb-1">{pkg.title}</h4>
                                      <p
                                        className="text-muted mb-0"
                                        style={{ fontStyle: "italic", fontSize: "14px" }}
                                      >
                                        {pkg.subtitle}
                                      </p>
                                    </div>

                          
                                    <ul className="list-unstyled text-start flex-grow-1 mb-1 px-2">
                                      {Object.keys(pkg.detailedFeatures).map((feature, idx) => (
                                        <li key={idx} className="d-flex align-items-center mb-2">
                                          <span
                                            className={`me-2 fw-bold ${pkg.detailedFeatures[feature] ? "text-success" : "text-danger"
                                              }`}
                                          >
                                            {pkg.detailedFeatures[feature] ? "✅" : "❌"}
                                          </span>
                                          <span className="text-dark">{feature}</span>
                                        </li>
                                      ))}
                                    </ul>

                         
                                    {pkg?.price ? (
                                      <p className="fw-semibold mb-4 mt-auto">
                                        Starts from ₹{pkg.price}
                                      </p>
                                    ) : null}

                         
                                    <button
                                      className="btn text-white w-100"
                                      style={{ backgroundColor: "#a259ff", borderRadius: "10px" }}
                                      onClick={() => navigateTheater("/locations")}
                                    >
                                      {pkg.buttonText}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                   
                      <button
                        className="carousel-control-prev"
                        type="button"
                        data-bs-target="#packagesCarousel"
                        data-bs-slide="prev"
                      >
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button
                        className="carousel-control-next"
                        type="button"
                        data-bs-target="#packagesCarousel"
                        data-bs-slide="next"
                      >
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                </section> */}

                <HomePackagesSection navigateTheater={navigate} />



                <section className="py-5 bg-white">
                  <div className="container">
                    <div className="row justify-content-between align-items-center rounded-4 p-4 shadow lighter-back">
                      {/* Text Column */}
                      <div className="col-12 col-md-8 mb-3 mb-md-0">
                        <h4 className="fw-bold dark-text mb-2">Follow Our Journey on Instagram</h4>
                        <p className="text-muted m-0">Get inspired by our latest creations and behind-the-scenes moments.</p>
                      </div>

                      {/* Button Column */}
                      <div className="col-12 col-md-4 text-md-end">
                        <a
                          href="https://www.instagram.com/accounts/login/?next=%2Fcarnival_castle_hyderabad%2F&source=omni_redirect"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill text-decoration-none fw-semibold"
                          style={{
                            background: "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)",
                            color: "#fff",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                          }}
                        >
                          <i className="fab fa-instagram"></i> carnival_castle_hyderabad
                        </a>
                      </div>
                    </div>
                  </div>
                </section>



                <CouponSection />


                {/* <section className="py-5 position-relative text-dark" style={{ backgroundColor: "#E6D8F5" }}>
                  <Container fluid="lg">
                    <Row className="align-items-center">
                      
                      <Col lg={3} className="text-center text-lg-start mb-4 mb-lg-0">
                        <h2 className="fw-bold mt-3 dark-text">Our Theatres</h2>
                        <p className="light-text fs-6">
                          Real stories. Real celebrations. Real magic at Carnival Castle.
                        </p>
                      </Col>

            
                      <Col lg={9}>
                        <div className="d-flex align-items-center justify-content-center overflow-auto gap-3">
                          
                          {testimonials
                            .filter((item) => item.videoId !== selected.videoId)
                            .map((user, idx) => (
                              <div
                                key={idx}
                                className="side-card d-flex align-items-center justify-content-center rounded shadow"
                                style={{
                                  width: "80px",
                                  height: "280px",
                                  backgroundImage: `url(${user.thumbnail})`,
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  cursor: "pointer",
                                  position: "relative",
                                }}
                                onClick={() => setSelected(user)}
                              >
                                <h6 className="vertical-text text-white fw-bold m-0">{user.name}</h6>
                                <div className="overlay"></div>
                              </div>
                            ))}

                        
                          <div
                            className="main-video-card position-relative rounded shadow overflow-hidden"
                            style={{
                              width: "300px",
                              height: "400px",
                              backgroundColor: "#000",
                            }}
                          >
                            <iframe
                              width="100%"
                              height="80%"
                              src={`https://www.youtube.com/embed/${selected.videoId}?autoplay=1&mute=1`}
                              title={selected.name}
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                            ></iframe>

                            
                            <div className="position-absolute bottom-0 start-0 end-0 p-3">
                              <div className="bg-white d-inline-block px-3 py-2 rounded-4 w-100 shadow-sm">
                                <strong className="dark-text">{selected.name}</strong><br />
                                <small className="text-dark">{selected.role}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>

                 
                  <style jsx>{`
        .side-card {
          position: relative;
          overflow: hidden;
        }

        .vertical-text {
          writing-mode: vertical-rl;
          text-orientation: mixed;
          transform: rotate(180deg);
          font-size: 1rem;
          z-index: 2;
        }

        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.4);
          z-index: 1;
        }

        .main-video-card iframe {
          border: none;
        }
      `}</style>
                </section> */}



                {/* FAQS */}
                <section className="pb-3 bg-white">
                  <div className="container">
                    <div className="section-wraper row d-flex align-items-center">

                      <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-8">
                          <div className="section-title text-center mb-5 pt-3">
                            <h2 className="dark-text">
                              Frequently Asked Questions
                            </h2>
                          </div>
                        </div>
                      </div>

                      <div className="row justify-content-center">
                        <div className="col-md-8">

                          <Accordion defaultActiveKey="0">
                            {(showAllFaqs ? Faqs : Faqs?.slice(0, 4))?.map((data, i) => (
                              <Accordion.Item
                                className="mt-3"
                                eventKey={i.toString()}
                                key={i}
                                style={{ background: "white" }}
                              >
                                <Accordion.Header>
                                  <b>
                                    {i + 1}. {data.question}
                                  </b>
                                </Accordion.Header>

                                <Accordion.Body>
                                  {data.answer}
                                </Accordion.Body>
                              </Accordion.Item>
                            ))}
                          </Accordion>

                          {Faqs?.length > 4 && (
                            <div className="text-center mt-4">

                              {/* View More Button */}
                              <button
                                className="btn btn-outline-dark fw-semibold mb-3"
                                onClick={() => setShowAllFaqs(!showAllFaqs)}
                              >
                                {showAllFaqs ? "View Less" : "View More"}
                              </button>

                              {/* WhatsApp Button */}
                              <div>
                                <a
                                  href="https://wa.me/918374777834?text=Hello%2C%20I%20want%20to%20book%20tickets."
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn fw-bold whatsapp-btn responsive-btn"
                                >
                                  <i className="bi bi-whatsapp me-2"></i>
                                  Chat With Us
                                </a>
                              </div>

                            </div>
                          )}

                        </div>

                        {/* <div className="col-md-12 text-center mt-3 mb-4">
          <a
            href="/locations"
            className="btn btn-primary fw-bold dark-back"
          >
            Book Now
          </a>
        </div> */}

                      </div>
                    </div>
                  </div>
                </section>

                <section className="pt-5 bg-white">
                  <div
                    className="container-fluid text-center py-5"
                    style={{ backgroundColor: "#e7d2f3" }}
                  >
                    <h2 className="fw-bold mb-5 dark-text">Our Branches</h2>

                    <div className="d-flex flex-wrap justify-content-center gap-3">
                      {addresses.map((addr, idx) => (
                        <a
                          key={idx}
                          href={addr.addressLine2}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "10px",
                            background: "#fff",
                            border: "1.5px solid rgba(109,40,217,0.15)",
                            borderRadius: "999px",
                            padding: "10px 20px 10px 12px",
                            textDecoration: "none",
                            boxShadow: "0 4px 16px rgba(109,40,217,0.12), 0 1px 4px rgba(0,0,0,0.05)",
                            transition: "all 0.2s ease",
                            cursor: "pointer",
                          }}
                          onMouseEnter={e => {
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow = "0 8px 24px rgba(109,40,217,0.22), 0 2px 6px rgba(0,0,0,0.06)";
                            e.currentTarget.style.borderColor = "rgba(109,40,217,0.35)";
                          }}
                          onMouseLeave={e => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 4px 16px rgba(109,40,217,0.12), 0 1px 4px rgba(0,0,0,0.05)";
                            e.currentTarget.style.borderColor = "rgba(109,40,217,0.15)";
                          }}
                        >
                          {/* Icon bubble */}
                          <span style={{
                            width: "34px", height: "34px",
                            borderRadius: "999px",
                            background: "linear-gradient(135deg,#6d28d9,#a855f7)",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            flexShrink: 0,
                            boxShadow: "0 2px 8px rgba(109,40,217,0.3)",
                          }}>
                            <i className="bi bi-geo-alt-fill" style={{ color: "#fff", fontSize: "14px" }} />
                          </span>

                          {/* Text */}
                          <span style={{ textAlign: "left" }}>
                            <span style={{
                              display: "block",
                              fontWeight: 700,
                              fontSize: "13px",
                              color: "#1a1a2e",
                              lineHeight: 1.3,
                            }}>
                              {addr.name}
                            </span>

                          </span>

                          {/* Arrow */}
                          <span style={{ color: "#a855f7", fontSize: "12px", marginLeft: "4px" }}>↗</span>
                        </a>
                      ))}
                    </div>
                  </div>

                  <style jsx>{`
    .text-purple { color: #5b179b; }
  `}</style>
                </section>


                {/* <Modal
                  size="md"
                  show={lgShow}
                  onHide={handleClose}
                  aria-labelledby="example-modal-sizes-title-lg"
                  centered
                >
                  <div style={{ position: "relative", width: "100%" }}>
                    <img
                      src={URLS.Base + PopUp.image}
                      alt="image"
                      style={{ width: "100%", objectFit: "cover" }}
                    />
                    <button
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        background: "rgba(0, 0, 0, 0.5)",
                        border: "none",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                      onClick={handleClose}
                    >
                      &times;
                    </button>
                  </div>
                </Modal> */}

                <PopupModal
                  show={showPopup}
                  handleClose={() => setShowPopup(false)}
                  image={popupImage}
                />
                <ToastContainer />
                <Footer />
              </>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default Home;
